<template>
  <div class="mt-6 md:mt-10">
    <ul id="grid" class="clear">
      <hexagon-grid-element
          v-for="feature of features"
          :feature="feature"
          :is-selected="featureIndex(feature.key) >= 0"
          :key="feature.key"
          @onClick="onFeatureClick"/>
    </ul>
  </div>
</template>

<script>
import HexagonGridElement from "@/components/calculator-steps/utils/HexagonGridElement";

export default {
  name: "StepFourHexagonGrid",
  components: {
    HexagonGridElement
  },
  data: () => ({
    features: [
      {text: 'Lihtne hinnapäringu vorm', key: 'basicPriceInquiry'},
      {text: 'Genereeritud hinnapäringu vorm', key: 'complexPriceInquiry'},
      {text: 'Broneeringu süsteem', key: 'booking'},
      {text: 'Kontaktvorm', key: 'contactForm'},
      {text: 'Uudiskirjaga liitumine', key: 'leadCeneration'},
      {text: 'Blogi', key: 'blog'},
      {text: 'Uudistevoog', key: 'newsFeed'},
      {text: 'Kalender', key: 'calendar'},
      {text: 'Sisutekstide loomine', key: 'contentCreation'},
      {text: 'Tootekataloog', key: 'directory'},
    ],
    selected: []
  }),
  methods: {
    featureIndex(featureKey) {
      return this.selected.findIndex(el => el === featureKey)
    },
    onFeatureClick(featureKey) {
      const featureIndex = this.featureIndex(featureKey)
      if (featureIndex >= 0) {
        this.selected.splice(featureIndex, 1)
      } else {
        this.selected.push(featureKey)
      }
      this.$store.dispatch('prices/ADDITIONAL', this.selected)
    }
  }
};
</script>

<style>
</style>
